/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * Hovering must not re-check the whole app. Nearly every (mouseenter)/(mouseleave) binding (460+ of them) only
 * shows or hides the global tooltip, which is plain DOM work - but as patched events each one ran a full change
 * detection pass of the page (twice per hover: enter and leave), which is what made hovering over tables laggy.
 * Left unpatched, those handlers run outside Angular. A hover handler that changes what the page shows has to step
 * back in itself with NgZone.run - see DescriptionDropdownComponent.openCategory / scheduleCloseCategory and
 * CompaniesContactsSelectPage.SetCompanyInfo.
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mouseenter', 'mouseleave'];
